import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import type * as models from './models'
/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State {
  /** @see {@link models.EntityUsage} */
  entityUsageLookup: models.EntityUsage.Lookup

  /** TODO: document */
  editingCustomLabel?: {
    selectionTarget: ec.models.Target
    label?: string
  }
}
export namespace State {
  export const INITIAL: State = {
    entityUsageLookup: {},
  }

  export function referenceEntityIds(
    state: State,
    referenceTarget: ec.models.Target,
    ...entityIds: readonly ec.models.EntityId[]
  ): State {
    state = { ...state }

    for (const entityId of entityIds) {
      state = _referenceEntityId(state, referenceTarget, entityId)
    }

    return state
  }

  export function dereferenceEntityIds(
    state: State,
    referenceTarget: ec.models.Target,
    ...entityIds: readonly ec.models.EntityId[]
  ): State {
    state = { ...state }

    for (const entityId of entityIds) {
      state = _dereferenceEntityId(state, referenceTarget, entityId)
    }

    return state
  }

  export function getReferencedEntityIds(
    state: State,
    target: ec.models.Target,
  ): ec.models.EntityId[] {
    throw new Error('Implement')
  }
}

/** TODO:  */
function _dereferenceEntityId(
  state: State,
  referenceTarget: ec.models.Target,
  entityId: ec.models.EntityId,
): State {
  state = { ...state }
  const entityUsage = state.entityUsageLookup[entityId]

  if (entityUsage) {
    entityUsage.referencedBy.delete(referenceTarget)
  }

  return state
}

/** TODO:  */
function _referenceEntityId(
  state: State,
  referenceTarget: ec.models.Target,
  entityId: ec.models.EntityId,
): State {
  state = { ...state }
  let entityUsage = state.entityUsageLookup[entityId]

  entityUsage ??= {
    deletable: true,
    referencedBy: new Set(),
  }

  entityUsage.referencedBy.add(referenceTarget)

  return state
}
